

define(['angular', 'squid/index'], function (angular, squid) {

    (function exportProviders(angular) {
        angular && angular.exportProviders(module, exports, __dirname, __filename);
    })(window.angular);

    squid.module('xo-cart.pxp', ['squid.pxp']).factory('$pxpCartAmt', function ($pxp, $q) {
        return function (merchantCountry, merchantId, noLineItemDetails, isPurchase) {

            if (merchantCountry !== 'AU' && noLineItemDetails && isPurchase) {

                var pageName = 'xo_hermes_no_line_item_details';
                var showAmtBlacklistTreatment = 'xo_hermes_no_line_items_show_amount_blacklist_test_group';
                var showAmtTreatment = 'xo_hermes_no_line_items_show_amount_test_group';

                return $q.all([$pxp(pageName, {
                    'ctx.merchantID': merchantId,
                    uid: merchantId
                }, showAmtBlacklistTreatment), $pxp(pageName, {
                    'ctx.merchantID': merchantId,
                    uid: merchantId
                }, showAmtTreatment)]).then(function (results) {
                    var showAmtBlacklist = results[0];
                    var showAmt = results[1];

                    if (showAmtBlacklist && showAmtBlacklist.treatment_name === showAmtBlacklistTreatment) {
                        return true;
                    }

                    if (showAmt && showAmt.treatment_name === showAmtTreatment) {
                        return true;
                    }

                    return false; // default to hide
                });
            }

            return $q.when(!noLineItemDetails && isPurchase);
        };
    });
});


//////////////////
// WEBPACK FOOTER
// ./components/xo-page-components/src/cart/lib/pxp.js
// module id = ./components/xo-page-components/src/cart/lib/pxp.js
// module chunks = 1